import jsZip from "jszip";
import {baseUrl} from "../../Constants/constants";
import saveAs from "file-saver";
import axios from "axios";
import {apiGet} from "../../Api";
import sanitize from "sanitize-filename";

function isWindows() {
  return navigator && navigator.platform.indexOf('Win') > -1
}

export default async function createZipDownload(activities, elem) {
  return new Promise(resolve => {
    let zip = new jsZip();
    let materials = [];
    let materialsSaved = [];
    let activityIndexes = {};
    let event = new Event('update');

    const formatPhases = (phase) => {
      switch (phase) {
        case ("Who's our partner?"):
          return "01 Who's our partner?";
        case ("What's our project?"):
          return "02 What's our project?";
        case ("What's our product?"):
          return "03 What's our product?";
        default:
          return "04 General";
      }
    };

    apiGet(`/entity_subqueue/activity_queue?include=items&jsonapi_include=1`)
      .then( result => {
        let activitiesQueResult = result.data.data[0].items;
        activitiesQueResult.forEach( (a, i) => {
          activityIndexes[a.id] = i + 1
        });

        activities.forEach( (activity, a) => {
          if (activity.field_materials && activity.field_materials.length > 0) {
            activity.field_materials.map(material => {
              materials.push({
                filename: sanitize(formatPhases(activity.field_course_phase.name)) + "/" + sanitize(activity.title) + "/" + sanitize(material.filename),
                url: baseUrl + material.uri.url
              })
            });
          }
        });

        if(materials.length === 0) {
          resolve(true);
        }

        for (let i = 0; i < materials.length; i++) {
          axios.get("https://courses.olin.edu/proxy/" + materials[i].url,
            {
              responseType: 'arraybuffer',
              headers: {
                'Content-Type': '*',
                'Accept': '*'
              }
            })
            .then((response) => {
              const blob = new Blob([response.data]);
              zip.file(materials[i].filename, blob, {binary:true});

              materialsSaved.push(materials[i].filename);
              if (elem) {
                elem.dispatchEvent(event);
              }

              if (materialsSaved.length === materials.length) {
                zip.generateAsync({
                  type:"blob",
                  platform: isWindows() ? "DOS" : "UNIX"
                }).then(function(content) {
                  // see FileSaver.js
                  saveAs(content, sanitize("Engineering for Humanity Activities.zip"));
                  resolve(true);
                });
              }
            })
        }

      });
  });
}
